import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import Header from "../components/Header";
import PasswordInput from "../components/PasswordInput";
import { Card } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";

export default function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { identifier, password });
      setUser(data);
      toast.success(`Bem-vindo(a), ${data.name.split(" ")[0]}!`);
      if (data.account_type === "buyer") {
        navigate("/dashboard");
      } else if (data.activation_status && data.activation_status !== "approved") {
        navigate("/aguardando-ativacao");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-28 max-w-md mx-auto px-4">
        <Card className="p-8 gold-border">
          <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Acesso</div>
          <h1 className="font-display text-3xl font-bold mt-1">Entrar na <span className="gold-text">Conecta Mais</span></h1>

          <form className="mt-6 space-y-4" onSubmit={submit}>
            <div>
              <Label htmlFor="identifier">E-mail ou CPF</Label>
              <Input id="identifier" value={identifier} onChange={(e) => setIdentifier(e.target.value)}
                     required data-testid="login-identifier" autoComplete="username" />
            </div>
            <div>
              <Label htmlFor="password">Senha</Label>
              <PasswordInput id="password" value={password} onChange={(e) => setPassword(e.target.value)}
                     required data-testid="login-password" autoComplete="current-password" />
            </div>
            <Button type="submit" disabled={loading} className="gold-btn w-full hover:opacity-95" data-testid="login-submit">
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>

          <div className="mt-4 flex items-center justify-between text-sm">
            <Link to="/esqueci-senha" className="text-muted-foreground hover:text-foreground" data-testid="forgot-link">
              Esqueci minha senha
            </Link>
            <Link to="/cadastro" className="gold-text font-medium" data-testid="register-link">
              Criar conta
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
